<template>
  <div
    v-if="businessContactInfo"
  >
    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      :href="businessContactInfo.fields.businessContactCallToAction.fields.action"
      outlined
      target="_blank"
    >
      {{ businessContactInfo.fields.businessContactCallToAction.fields.title }}
    </base-btn>
  </div>
</template>

<script>
  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    data () {
      return {
        businessContactInfo: null,
      }
    },

    async mounted () {
      const { items } = await this.$contentful.getEntries({
        content_type: 'businessContactInfo',
        select: 'fields',
      })
      const [entry] = items
      this.businessContactInfo = entry
    },
  }
</script>
